import { createContext, useContext } from "react";

export interface UserChannelContextType {
  channelName: string | undefined;
}

export const UserChannelContext = createContext<UserChannelContextType | null>(null);

export const useUserChannel = () => {
  const context = useContext(UserChannelContext);
  if (!context) {
    throw new Error("useUserChannel must be used within UserChannelProvider");
  }
  return context;
};
